import {
	printObj
} from "@/utils/debug"

import {
	getAllRoleApplication
} from "@/api/system/diagnosisManagement/diagnosticRoleApplication"

// import {
// 	getUserCertificationList,
// } from "@/api/userManagement";
import{
	getAllExpertList
} from "@/api/expertManagement"
import {
	getCreditRulesList
} from "@/api/mai/creditRules/creditRulesManegement";

const state = {
	hasNewMsg: false,
	expertAuthenticationNo: 0,
	consultationAuthenticationNo: 0,
}

const mutations = {
	SET_EXPERT_AUTHENTICATION_NO: (state, no) => {
		// printObj(state);
		// eslint-disable-next-line no-prototype-builtins
		state.expertAuthenticationNo = no
		if (state.expertAuthenticationNo > 0 || state.consultationAuthenticationNo > 0) {
			state.hasNewMsg = true;
		}else{
			state.hasNewMsg = false;
		}
	},
	SET_CONSULTATION_AUTHENTICATION_NO: (state, no) => {
		// printObj(state);
		// eslint-disable-next-line no-prototype-builtins
		state.consultationAuthenticationNo = no
		if (state.expertAuthenticationNo > 0 || state.consultationAuthenticationNo > 0) {
			state.hasNewMsg = true;
		}else{
			state.hasNewMsg = false;
		}
	},
	SET_HAS_NEW_MSG: (state, hasnew) => {
		printObj(state);
		// eslint-disable-next-line no-prototype-builtins
		state.hasNewMsg = hasnew
	},
}

const actions = {
	setExpertAuthenticationNo({
		commit
	}) {
		//用户证件认证
		// getUserCertificationList({
		// 	where: [{
		// 		"field": "certificateStatus",
		// 		"value": 0,
		// 		"op": "equal"
		// 	}]
		// }).then((res) => {
		// 	if (res.code === 200) {
		// 		let no = res.data.total
		// 		console.log("setExpertAuthenticationNo " + no)
		// 		commit("SET_EXPERT_AUTHENTICATION_NO", no);
		// 	}
		// }\)
		
		// 普通专家认证
		// getAllExpertList({
		// 	where: [{
		// 		"field": "isAudited",
		// 		"value": false,
		// 		"op": "equal"
		// 	}]
		// }).then((response) => {
		// 	if (response.code === 200) {
		// 		let no = response.data.total
		// 		console.log("setConsultationAuthenticationNo " + no)
		// 		commit("SET_CONSULTATION_AUTHENTICATION_NO", no);
		// 	}
		// })
	},
	setConsultationAuthenticationNo({
		commit
	}) {
		getAllRoleApplication({
			where: [{
				"field": "auditStatus",
				"value": 0,
				"op": "equal"
			}]
		}).then((response) => {
			if (response.code === 200) {
				let no = response.data.total
				console.log("setConsultationAuthenticationNo " + no)
				commit("SET_CONSULTATION_AUTHENTICATION_NO", no);
			}
		})
	},
	setHasNewMsg({
		commit
	}, hasNewMsg) {
		commit("SET_HAS_NEW_MSG", hasNewMsg);
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
